const asmConstants = {
  CREATE_ASM_USER_IN_PROGRESS: "CREATE_ASM_USER_IN_PROGRESS",
  CREATE_ASM_USER_SUCCESS: "CREATE_ASM_USER_SUCCESS",
  CREATE_ASM_USER_FAILURE: "CREATE_ASM_USER_FAILURE",
  FIND_ASM_USERS_IN_PROGRESS: "FIND_ASM_USERS_IN_PROGRESS",
  UPDATE_ASM_USERS_LIST: "UPDATE_ASM_USERS_LIST",
  FIND_ASM_USERS_SUCCESS: "FIND_ASM_USERS_SUCCESS",
  FIND_ASM_USERS_FAILURE: "FIND_ASM_USERS_FAILURE",
  SET_SELECTED_ASM_USER_DETAILS: "SET_SELECTED_ASM_USER_DETAILS",
  END_CUSTOMER_SESSION_IN_PROGRESS: "END_CUSTOMER_SESSION_IN_PROGRESS",
  END_CUSTOMER_SESSION_SUCCESS: "END_CUSTOMER_SESSION_SUCCESS",
  END_CUSTOMER_SESSION_FAILURE: "END_CUSTOMER_SESSION_FAILURE",
  RESET_TIMER_FLAG: "RESET_TIMER_FLAG",
  FIND_ASM_USER_CART_IN_PROGRESS: "FIND_ASM_USER_CART_IN_PROGRESS",
  FIND_ASM_USER_CART_SUCCESS: "FIND_ASM_USER_CART_SUCCESS",
  FIND_ASM_USER_CART_FAILURE: "FIND_ASM_USER_CART_FAILURE",
  RESET_FIND_ASM_USER_CART_ERROR: "RESET_FIND_ASM_USER_CART_ERROR",
  ACCOUNT_EMAIL_UPDATE_SUCCESS: "ACCOUNT_EMAIL_UPDATE_SUCCESS",
  GET_ASM_PRICE_OVERRIDE_REASONS_SUCCESS:
    "GET_ASM_PRICE_OVERRIDE_REASONS_SUCCESS",
  GET_ASM_PRICE_OVERRIDE_REASONS_FAILURE:
    "GET_ASM_PRICE_OVERRIDE_REASONS_FAILURE",
  ASM_OVERRIDE_CART_PRICE_IN_PROGRESS: "ASM_OVERRIDE_CART_PRICE_IN_PROGRESS",
  ASM_OVERRIDE_CART_PRICE_SUCCESS: "ASM_OVERRIDE_CART_PRICE_SUCCESS",
  ASM_OVERRIDE_CART_PRICE_FAILURE: "ASM_OVERRIDE_CART_PRICE_FAILURE",
  SET_FIND_CUSTOMER_ERROR: "SET_FIND_CUSTOMER_ERROR",
  RESET_FIND_CUSTOMER_ERROR: "RESET_FIND_CUSTOMER_ERROR",
  UPDATE_FIND_CUSTOMER_CURRENT_PAGE_NUMBER:
    "UPDATE_FIND_CUSTOMER_CURRENT_PAGE_NUMBER",
  ADD_ORDER_REFERENCE_NUMBER_IN_PROGRESS:
    "ADD_ORDER_REFERENCE_NUMBER_IN_PROGRESS",
  ADD_ORDER_REFERENCE_NUMBER_SUCCESS: "ADD_ORDER_REFERENCE_NUMBER_SUCCESS",
  ADD_ORDER_REFERENCE_NUMBER_FAILURE: "ADD_ORDER_REFERENCE_NUMBER_FAILURE",
  RESET_ADD_ORDER_REFERENCE_NUMBER_MSGS:
    "RESET_ADD_ORDER_REFERENCE_NUMBER_MSGS",
  TOGGLE_ASM_SHOPPING_PRICE_OVERRIDE: "TOGGLE_ASM_SHOPPING_PRICE_OVERRIDE",
  GET_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_SUCCESS:
    "GET_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_SUCCESS",
  GET_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_FAILURE:
    "GET_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_FAILURE",
  OVERRIDE_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_SUCCESS:
    "OVERRIDE_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_SUCCESS",
  OVERRIDE_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_FAILURE:
    "OVERRIDE_ASM_SHOPPING_PRICE_OVERRIDE_REASONS_FAILURE",
  ADD_CUSTOMER_TO_GUEST_LIST: "ADD_CUSTOMER_TO_GUEST_LIST",
  ADD_CUSTOMER_TO_REGISTER_LIST: "ADD_CUSTOMER_TO_REGISTER_LIST",
  REMOVE_CUSTOMER_FROM_GUEST_LIST: "REMOVE_CUSTOMER_FROM_GUEST_LIST",
  REMOVE_CUSTOMER_FROM_REGISTER_LIST: "REMOVE_CUSTOMER_FROM_REGISTER_LIST",
  RESET_ASM_MERGE_ACCOUNTS_ERROR: "RESET_ASM_MERGE_ACCOUNTS_ERROR",
  MERGE_CUSTOMER_ACCOUNTS_IN_PROGRESS: "MERGE_CUSTOMER_ACCOUNTS_IN_PROGRESS",
  MERGE_CUSTOMER_ACCOUNTS_SUCCESS: "MERGE_CUSTOMER_ACCOUNTS_SUCCESS",
  MERGE_CUSTOMER_ACCOUNTS_FAILURE: "MERGE_CUSTOMER_ACCOUNTS_FAILURE",
  RENDER_SELECT_CUSTOMER_CHECK_BOX: "RENDER_SELECT_CUSTOMER_CHECK_BOX",
}

export default asmConstants
